module.exports = __webpack_public_path__ + "img/learningpath_landingpage.49be8547.png";